


















import Vue, { PropOptions } from 'vue';
import { formatDate } from '@/web/utils/format';
interface Props {
  lesson: PropOptions;
}
export default Vue.extend({
  name: 'ProductLessonScheduleItem',
  props: {
    lesson: {
      type: Object as () => LessonResponse,
      required: true,
    },
  } as Props,
  computed: {
    lessonStartType(): string {
      if (!this.lesson || !this.lesson.lesson_start_type) return 'SET_START';
      return this.lesson?.lesson_start_type?.toUpperCase();
    },
    lessonStartValue(): number | string | null {
      switch (this.lesson.lesson_start_type) {
        case 'after_specific_days':
          return this.lesson.lesson_start_after_days;
        case 'after_specific_date':
          return formatDate(this.lesson.lessons_start_after_date, 'date');
        default:
          return null;
      }
    },
  },
});
